import {
    computeBoundsTree,
    disposeBoundsTree,
    acceleratedRaycast,
} from "three-mesh-bvh";
import "./systems/input-mapping/input-mapping";
import "./systems/input-mapping/mappings/input-mappings";

import "./systems/gltf-system";
import "./components/animation-mixer";
import "./components/raycastervr";
import "./components/cursor-controller";
import "./components/trimesh-shape";
import "./components/kinematic-body";
import "./components/gltf-model-plus";
import "./components/wasd-to-analog2d";
import "./components/character-controller";
import "./components/link-oninteract";

import { createScene, renderEntities } from "./objects/scene";
import { createPlayer } from "./objects/player";
import { createCursor } from "./objects/cursor";

// Add the extension functions
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;

const main = async () => {
    if (document.readyState !== "complete") {
        document.addEventListener("readystatechange", main);
        return;
    }
    const soundButtonEl = document.getElementById("sound-button");
    const progressEl = document.querySelector(".progress");
    const overlayEl = document.querySelector(".overlay");
    const room = await fetch("assets/room.json").then((res) => res.json());
    const ascene = createScene();
    const player = createPlayer();
    const cursor = createCursor();

    ascene.addEventListener("glb-loading-progress", ({ detail }) => {
        if (detail.progress < 85) {
            progressEl.style.backgroundSize = `${detail.progress}%`;
        }
    });

    ascene.addEventListener("glb-models-loaded", () => {
        progressEl.style.backgroundSize = `100%`;

        setTimeout(() => {
            overlayEl.style.display = "none";
        }, 500);
    });

    ascene.appendChild(cursor);

    renderEntities(room.glbmodelsattr, ascene);

    ascene.appendChild(player);

    const soundEntity = document.querySelector(".entityAudio");
    const soundComponent = soundEntity.components.sound;
    const updateSoundIcons = () => {
        const isPlaying = soundComponent.isPlaying;
        soundButtonEl.classList.toggle("on", isPlaying);
        soundButtonEl.classList.toggle("off", !isPlaying);
    };

    const toggleSound = () => {
        const isPlaying = soundComponent.isPlaying;

        if (isPlaying) {
            soundComponent.pauseSound();
        } else {
            soundComponent.playSound();
        }

        updateSoundIcons();
    };

    soundButtonEl.addEventListener("click", toggleSound);

    document.addEventListener("body-loaded", (t) => {
        document.querySelector("#player-rig").setAttribute("kinematic-body", {
            radius: 0.6,
            friction: -1,
        });
    });
};

main();
